var snapCanvas = document.createElement("canvas");
snapCanvas.width = 352;	//640;
snapCanvas.height = 288; //480;
const context = snapCanvas.getContext('2d', { willReadFrequently: true });

export function makeVideoImageSnap(videoElementId){
    //var snapVideo = document.getElementById(videoElementId);
    var snapVideo = document.getElementsByClassName(videoElementId)[0];
    if(!snapVideo){return null;}
    snapCanvas.getContext('2d').drawImage(snapVideo, 0, 0, snapCanvas.width, snapCanvas.height);
    const imageData = context.getImageData(0, 0, snapCanvas.width, snapCanvas.height).data;
    if(checkSnapForContent(imageData)){
        return snapCanvas.toDataURL("image/jpeg", 0.5);
    }
    return null;
}

function checkSnapForContent(imageData){
    if(isCanvasBlank(imageData)){
        return false;
    }
    if(isCanvasPaintedInOneColor(imageData)){
        return false;
    }
    return true;
}

function isCanvasBlank(imageData) {
  
    const pixelBuffer = new Uint32Array(
        imageData.buffer
    );
  
    return !pixelBuffer.some(color => color !== 0);
}

function isCanvasPaintedInOneColor(imageData) {
    const firstPixelColor = getPixelColor(imageData, 0);
  
    for (let i = 0; i < imageData.length; i += 4) {
      const pixelColor = getPixelColor(imageData, i);
      if (!areColorsEqual(firstPixelColor, pixelColor)) {
        return false;
      }
    }
  
    return true;
  }
  
  function getPixelColor(imageData, index) {
    const red = imageData[index];
    const green = imageData[index + 1];
    const blue = imageData[index + 2];
    const alpha = imageData[index + 3];
    return { red, green, blue, alpha };
  }
  
  function areColorsEqual(color1, color2) {
    return (
      color1.red === color2.red &&
      color1.green === color2.green &&
      color1.blue === color2.blue &&
      color1.alpha === color2.alpha
    );
  }